<template>
	<div
		class="model"
		v-if="data.model"
		:class="{ 'model-full-width': data.model_full_width }"
	>
		<a
			:href="largestUrl"
			target="_blank"
			title="Open in new window"
		>
			<img
				:src="largestUrl"
				:srcset="srcset"
				sizes="(max-width: 1024px) 100vw, 1024px"
			/>
		</a>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	props: {
		data: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	computed: {
		srcset() {
			if (!this.data.model) {
				return '';
			}

			return this.data.model
				.map((urlWidth) => {
					return `${urlWidth.url} ${urlWidth.width}w`;
				})
				.join(',');
		},
		largestUrl() {
			if (!this.data.model) {
				return '';
			}

			return [...this.data.model]
				.sort((a, b) => {
					return a.width - b.width;
				})
				.at(0)?.url;
		},
	},
});
</script>

<style scoped lang="scss">
.model {
	img {
		display: block;
		margin: 20px auto;
		height: auto;
		max-height: 400px;
		object-fit: contain;
	}

	&.model-full-width {
		column-span: all;
	}
}

@media print {
	.model {
		img {
			max-height: 200px;
		}
	}
}
</style>
